import React from "react";
import UserParticipant from "../Participant/UserParticipant";
const TeamList = (props) => {
    const { team, distanceUnit, distanceTarget } = props;
    return (React.createElement(React.Fragment, null, team.pages.map((page, i1) => page.map((teamMember, i2) => {
        const isLastFromList = i1 + 1 === team.pages.length && i2 + 1 === page.length;
        return (React.createElement("div", { key: `${teamMember.type}_${teamMember.id}`, id: `${teamMember.type}_${teamMember.id}`, className: !isLastFromList ? "border-bottom" : "" },
            React.createElement(UserParticipant, { maxRank: team.maxRank, participant: teamMember, isTeamList: true, distanceUnit: distanceUnit, totalMissionDistance: distanceTarget, showJersey: false })));
    }))));
};
export default TeamList;
